import { useClaimStrategy } from "./use-claim-strategy";
import { useStageGate } from "./use-stage-gate";

/**
 * Whether the claim set takes writes, as the server holds it: every position settled, or
 * the stages unlocked, after which a lapsed position no longer locks the set. False while
 * neither read has answered.
 */
export function useClaimSetWritable(taskId: string): boolean {
  const open = useStageGate(taskId).data?.open === true;
  const settled =
    useClaimStrategy(taskId).data?.gate.positions_settled === true;
  return open || settled;
}
